import React, { useEffect, useState } from "react";
import './Administrador.scss'
import TitleView from "../../components/atoms/TitleView/TitleView";
import GlovalCard from "../../components/atoms/GlovalCard/GlovalCard";
import { MultiSelect } from 'primereact/multiselect';
import { agregarPermiso, asignarPermiso, getInfoUsuario, getPermisos, getPermisosUsuario, getUsuariosAdimistrativos, updatePermiso } from "./AdministradorIntegracion";
import InputLista from "../../components/atoms/InputLista/InputLista";
import Button from "../../components/atoms/Button/Button";
import { useNavigate, useParams } from "react-router-dom";
const Administrador = ({ editar }) => {
    const navigate = useNavigate()
    const [usuario, setUsuario] = useState()
    const [usuarios, setUsuarios] = useState()
    const [permisos, setPermisos] = useState()
    const [permiso, setPermiso] = useState()
    const [privilegios, setPrivilegios] = useState()

    const [sendData, setSendData] = useState([])

    const params = useParams()


    useEffect(() => {
        if (editar) {
            getPermisos(setPermisos)
            getPermisosUsuario(setPermiso, params.id_usuario)
            getInfoUsuario(setUsuario, params.id_modulo, params.id_usuario)
            // getUsuariosAdimistrativos(setUsuarios)
        }
        else {
            getUsuariosAdimistrativos(setUsuarios)
            getPermisos(setPermisos)
        }

    }, [])
    useEffect(() => {
        if (usuario && !editar) {
            getPermisosUsuario(setPermiso, usuario.code)
        }
        else{
            setPrivilegios(usuario?.PRIVILEGIOS)
        }
    }, [usuario])
    useEffect(() => {
        if (permiso) {
            const preparandoSendData = []
            permiso.map((item) => {
                preparandoSendData.push({ name: item.name, code: item.code, privilegios: "L" })
            })
            setSendData(preparandoSendData)
        }
    }, [permiso])

    const sendPermisos = () => {
        if(!editar)
        {
            sendData.map((item) => {
                agregarPermiso(usuario.code, item)
            })
            navigate("/administrador")
        }
        else
        {
            updatePermiso(params.id_usuario,params.id_modulo,privilegios,navigate)
        }

    }
    const cambiarPrivilegio = (e, key) => {
        let copiasendData = [...sendData]
        copiasendData[key].privilegios = e.target.value
        setSendData(copiasendData)
    }
    return (
        <div className="Administrador">
            <TitleView title={"Administrador"}></TitleView>
            <GlovalCard>
                <div className="container-inputs">
                    {
                        !editar ?
                            <>
                                <InputLista id="permisos" value={usuario} onChange={(e) => setUsuario(e.value)} options={usuarios} obligatory={false} placeholder={"Selecciona un usuario"} />
                                <MultiSelect id="empresas" value={permiso} onChange={(e) => setPermiso(e.value)} options={permisos} optionLabel="name"
                                    filter placeholder="Seleccion el permiso" maxSelectedLabels={6} className="w-full md:w-20rem" />
                            </> :
                            <>
                                <div className="titulo">{usuario?.NOMBRE}</div>
                            </>
                    }
                </div>
                <div className="contendor_tipo_permiso">
                    {
                        !editar ?
                            <>
                                {

                                    permiso?.map((item, key) => {
                                        return (
                                            <>
                                                <div className="tipo-container">
                                                    <div className="titulo">{item.name}</div>
                                                    <div className="tipos">
                                                        <div className="tipo-container">
                                                            <div className="lectua">Lectura</div>
                                                            <input type="radio" name={`${item.code}tipo`} checked={sendData[key]?.privilegios == "L"} value={"L"} onChange={(e) => { cambiarPrivilegio(e, key) }} />
                                                        </div>
                                                        <div className="tipo-container">
                                                            <div className="lectua">Escritura</div>
                                                            <input type="radio" name={`${item.code}tipo`} checked={sendData[key]?.privilegios == "E"} value={"E"} onChange={(e) => { cambiarPrivilegio(e, key) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })
                                }
                            </> :
                            <>
                                <div className="tipo-container">
                                    <div className="titulo">{usuario?.MODULO}</div>
                                    <div className="tipos">
                                        <div className="tipo-container">
                                            <div className="lectua">Lectura</div>
                                            <input type="radio" name={`tipo`} checked={privilegios == "L"} value={"L"} onChange={(e) => { setPrivilegios(e.target.value) }} />
                                        </div>
                                        <div className="tipo-container">
                                            <div className="lectua">Escritura</div>
                                            <input type="radio" name={`tipo`} checked={privilegios == "E"} value={"E"} onChange={(e) => {  setPrivilegios(e.target.value)}} />
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                </div>
                <Button className={"botonActualizarpermisos"}  onClick={() => { sendPermisos() }}>ACTUALIZAR PERMISOS</Button>
            </GlovalCard>
        </div>
    )
}
export default Administrador